/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from "react"
import styled from "styled-components"
import _, { isEmpty, parseInt, get } from "lodash"
import root from "window-or-global"
import {
  Select, Button, Input, Switch, Modal, Spin,
} from "antd"
import Loader from "../../../common/UI/Loader"
import PlusSign from "./PlusOutlined.svg"
import { fetchComplianceTeamsAPI } from "../../../../container/AI/api"
import container from "../../../../container/BrokerDashboard/editAgentContainer"

const Wrap = styled.div`
  margin: 20px;
`
const Title = styled.h1`
  margin-top: 34px;
  margin-left: 17px;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  ${props => props.body && `
  margin-top: 0px;
  padding-left: 46px;
`}
`
const Content = styled.div`
  margin-top: 58px;
  margin-left: 17px;
  max-width: 1400px;
  height: 100%;
  .Content::-webkit-scrollbar {
    display: none;
  };
`
const HeaderWrap = styled.div`
  padding-left: 46px;
  padding-top: 48px;
  padding-right: 28px;
  display: flex;
  justify-content: space-between;
`
const AddNewDoc = styled.div`
  display: flex;
  margin-left: 48px;
  margin-top: 18px;
  cursor: pointer;
  ${props => props.colist && `
  margin-left: 0px;
`}

`
const Image = styled.img`
  margin-right: 16px;
`
const AddNew = styled.h3`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  color: #100063;
  margin: 0px;
`
const DropdownDiv = styled.div`
  display: flex;
`
const Subtitle = styled.h2`
  margin: 0px;
  margin-top: 6px;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  ${props => props.body && `
  margin-top: 0px;
  padding-left: 63px;
  font-size: 16px;
`}
`
const HR = styled.div`
  width: 100%;
  height: 0px;
  border: 1px solid #E6E6E6;
  margin-top: 32px;
  margin-left: 40px;
  ${props => props.colist && `
  margin-left: -9px;
  `}
  ${props => props.last && `
  margin-left: -9px;
  margin-bottom: 30px;
  `}
`
const Body = styled.div`
  // scroll: scroll;
  // overflow-x: hidden;
  height: 1000px;
  &::-webkit-scrollbar {
    display: none;
  }
`
const TitleDiv = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
`
const InfoDiv = styled.div`
  width: calc(100% - 100px);
  min-height: 102px;
  background: #FFFFFF;
  border: 1px solid #DDDDDD;
  margin-top: 87px;
  margin-left: 50px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  padding: 16px 20px;
  box-sizing: border-box;
  ${props => props.body && `
  margin-top: 23px;
  margin-bottom: 44px;
`}
${props => props.stuck && `
  margin-top: 0px;
  margin-bottom: 44px;
  margin-left: 0px;
`}
${props => props.first && `
  margin-top: 0px;
  margin-bottom: 44px;
`}
${props => props.owner && `
  padding-left: 0px;
  margin-left: 0px;
  margin-top: 23px;
`}
`
const Section = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 280px;
  min-width: 240px;
  ${props => props.team && `
    flex: 0 1 260px;
  `}
  ${props => props.action && `
    flex: 0 0 auto;
    min-width: auto;
  `}
`
const SmallTitle = styled.h3`
  font-size: 14px;
  font-weight: 200;
  margin-top: 8px;
`
const AdditionDocuments = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 86px;
`
const Divider = styled.div`
  display: flex;
  align-items: baseline;
  margin-bottom: 35px;
`
const SmallHR = styled.div`
  width: 400.5px;
  height: 0px;
  border: 1px solid #E6E6E6;
  margin-top: 32px;
  margin-left: 40px;
`
const SmallText = styled.h3`
  width: 158px;
  margin-left: 16px;
  margin-right: 16px;
  margin-bottom: 0px;
  margin-top: 0px;
  padding: 0px;
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
`
const MLSDiv = styled.div`
  display: flex;
  justify-content: space-between;
  width: 250px;
  ${props => props.body && `
  padding-left: 0px;
  `}
  ${props => props.contingency && `
    padding-left: 0px;
    width: 800px;
  `}
`
const Text = styled.p`
  margin: 0px;
  width: 553px;
  padding-left: 63px;
  margin-top: 20px;
  font-weight: 300;
  font-size: 14px;
  line-height: 17px;
  ${props => props.colist && `
  font-weight: 100;
  color: #8A8A8A;
  padding-left: 0;
  `}
  ${props => props.key && `
  font-weight: 100;
  padding-left: 0;
  `}
`
const TeamText = styled.p`
  margin: 0px;
  width: auto;
  padding-left: 0;
  margin-top: 8px;
  font-weight: 300;
  font-size: 14px;
  line-height: 17px;
  word-break: break-word;
  overflow-wrap: anywhere;
`
const CoListingDiv = styled.div`
  margin-top: 41px;
  padding-left: 46px;
`
const OwnershipDiv = styled.div`
  margin-top: 41px;
  padding-left: 46px;
`
const KeysafeDiv = styled.div`
  padding-left: 50px;
  margin-top: 35px;
`
const InvalidText = styled.h3`
  margin-top: 5px;
  margin-bottom: 0px;
  color: red;
  font-size: 12px;
`

const TitleWrap = styled.div`
  padding-left: 46px;
  padding-top: 48px;
  padding-right: 28px;
  display: flex;
  justify-content: flex-start;
`

const TitleAndTemplate = ({
  isEdit,
  valueName,
  valueTemplate,
  entityName,
  entityType,
  addArray,
  setAddArray,
  templateList,
  index,
  state,
  isShifted,
  templateData,
  setTemplateInvalid,
  setTemplateList,
  deleteTemplates,
  localTemplateData,
  setLocalTemplateData,
  teamsList = [],
}) => {
  const [name, setName] = useState("")
  const [template, setTemplate] = useState("")
  const currentTemplate = !isEmpty(templateList) ? templateList.find(x => x.idToAdd === index) : null
  const initialTeamId = currentTemplate && currentTemplate.team_id != null ? currentTemplate.team_id : undefined
  const [selectedTeamId, setSelectedTeamId] = useState(initialTeamId)
  const [isInvalidMessage, setIsInvalidMessage] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [invalidArray, setInvalidArray] = useState([])

  useEffect(() => {
    const nextTemplate = !isEmpty(templateList) ? templateList.find(x => x.idToAdd === index) : null
    setSelectedTeamId(nextTemplate && nextTemplate.team_id != null ? nextTemplate.team_id : undefined)
  }, [templateList, index])

  useEffect(() => {
    setName(valueName)
  }, [valueName])

  useEffect(() => {
    setTemplate(valueTemplate)
  }, [valueTemplate])

  const getTeamNameById = (teamId) => {
    if (teamId == null || teamId === undefined) return "-"
    const team = teamsList.find(t => Number(t.team_id) === Number(teamId))
    return team ? team.team_name : "-"
  }

  const handleAddTemplate = (nameTarget, templateTarget, teamIdVal = selectedTeamId) => {
    if (!isEmpty(templateList)) {
      templateList.map((x) => {
        if (x.idToAdd === index) {
          if (index.includes("old-")) {
            const id = parseInt((index.split("-").pop()), 10)
            x.name = nameTarget || ""
            x.id = id
            x.idToAdd = index
            x.templateId = templateTarget || ""
            x.entityName = entityName
            x.entityType = entityType
            x.state = state
            x.isEdited = true
            x.team_id = teamIdVal
          } else if (entityType === "mls_setup") {
            x.name = nameTarget || ""
            x.idToAdd = index
            x.templateId = templateTarget || ""
            x.entityType = entityType
            x.state = state
            x.team_id = teamIdVal
          } else {
            x.name = nameTarget || ""
            x.idToAdd = index
            x.templateId = templateTarget || ""
            x.entityName = entityName
            x.entityType = entityType
            x.state = state
            x.team_id = teamIdVal
          }
        }
      })
    }
  }

  const handleTeamChange = (newTeamId) => {
    const value = newTeamId || null
    setSelectedTeamId(value)
    if (!isEmpty(templateList)) {
      const next = templateList.map((x) => {
        if (x.idToAdd !== index) {
          return x
        }
        const updatedTemplate = {
          ...x,
          team_id: value,
        }
        if (index.includes("old-")) {
          updatedTemplate.id = parseInt((index.split("-").pop()), 10)
          updatedTemplate.isEdited = true
        }
        return updatedTemplate
      })
      setTemplateList(next)
    }
  }

  const handleDelete = (indexLocal) => {
    const checkId = indexLocal.split("-").pop()
    if (indexLocal.includes("old-")) {
      templateData.map((x) => {
        if (x.id.toString() === checkId) {
          deleteTemplates.push(x.id)
          localTemplateData.splice(localTemplateData.indexOf(x), 1)
          setLocalTemplateData([...localTemplateData])
        }
      })
    } else if (addArray.length > 1) {
      const localArr = addArray.filter((sc, ind) => ind.toString() !== checkId)
      setAddArray([...localArr])
    }
    templateList.map((x) => {
      if (x.idToAdd === indexLocal) {
        templateList.splice(templateList.indexOf(x), 1)
      }
    })

    const checkIdInTemplateDataIndex = templateData.findIndex(x => x.id.toString() === checkId)

    if (checkIdInTemplateDataIndex !== -1) {
      templateData.map((x) => {
        if (x.id.toString() !== checkId) {
          setTemplateInvalid(false)
        }
      })
    } else {
      setTemplateInvalid(false)
    }

    setDeleteModal(false)
  }

  //Function to keep save button disabled if even one template ID is duplicate
  const checkDisabled = () => {
    if (templateList.length > 1) {
      setInvalidArray([])
      templateList.map((x) => {
        templateList.map((y) => {
          if (x.templateId === y.templateId && x.idToAdd !== y.idToAdd) {
            invalidArray.push(y)
          }
        })
      })
      if (invalidArray.length > 0) {
        setTemplateInvalid(true)
      } else {
        setTemplateInvalid(false)
      }
    }
  }

  const checkIsDeleted = (indexLocal) => {
    const checkId = indexLocal.split("-").pop()
    deleteTemplates.map((x) => {
      if (x.toString() === checkId) {
        return true
      }
      return false
    })
  }

  const handleCancel = () => {
    setDeleteModal(false)
  }

  return (
    <>
      {!isShifted ? (
        <InfoDiv
          body
        >
          <Section>
            <SmallTitle>Title</SmallTitle>
            <Input
              placeholder="Enter the Document Name"
              disabled={!isEdit}
              style={{
                width: "100%",
                height: 32,
                background: "#F9F8FF",
                border: 1,
                borderColor: "#D9D9D9",
                borderRadius: 2,
                color: "black",
              }}
              value={name}
              onChange={(e) => {
                setName(e.target.value)
                handleAddTemplate(e.target.value, template)
              }}
            />
          </Section>
          <Modal
            title="Delete Template"
            visible={deleteModal}
            onOk={() => handleDelete(index)}
            onCancel={handleCancel}
          >
            Are you sure you want to delete this template?
          </Modal>
          <Section>
            <SmallTitle>Template ID</SmallTitle>
            <Input
              placeholder="Enter the Template ID"
              disabled={!isEdit}
              required
              style={{
                width: "100%",
                height: 32,
                background: "#F9F8FF",
                borderThickness: 1,
                borderColor: "#D9D9D9",
                borderRadius: 2,
                color: "black",
              }}
              value={template}
              onChange={(e) => {
                setTemplate(e.target.value)
                handleAddTemplate(name, e.target.value)
              }}
            />
            {isInvalidMessage === true ? (
              <>
                <InvalidText>* The Template ID is duplicate, please enter a different Template ID</InvalidText>
              </>
            ) : null}
          </Section>
          <Section team>
            <SmallTitle>Team</SmallTitle>
            {isEdit ? (
              <Select
                placeholder="Select team"
                allowClear
                style={{ width: "100%", height: 32 }}
                value={selectedTeamId}
                onChange={val => handleTeamChange(val)}
                options={(teamsList || []).map(t => ({ label: t.team_name, value: t.team_id }))}
              />
            ) : (
              <TeamText>{getTeamNameById(selectedTeamId)}</TeamText>
            )}
          </Section>
          {isEdit ? (
            <Section action>
              {checkIsDeleted === true ? (
                <Button
                  type="primary"
                  style={{
                    alignSelf: "center",
                  }}
                  disabled
                >
                  Deleted
                </Button>
              ) : (
                <Button
                  style={{
                    alignSelf: "center",
                  }}
                  onClick={() => setDeleteModal(true)}
                >
                  Delete
                </Button>

              )}
            </Section>
          ) : null}
        </InfoDiv>

      ) : (
        <InfoDiv
          owner
        >
          <Section>
            <SmallTitle>Title</SmallTitle>
            <Input
              placeholder="Enter the Document Name"
              disabled={!isEdit}
              style={{
                width: "100%",
                height: 32,
                background: "#F9F8FF",
                border: 1,
                borderColor: "#D9D9D9",
                borderRadius: 2,
                color: "black",
              }}
              value={name}
              onChange={(e) => {
                setName(e.target.value)
                handleAddTemplate(e.target.value, template)
              }}
            />
          </Section>
          <Modal
            title="Delete Template"
            visible={deleteModal}
            onOk={() => handleDelete(index)}
            onCancel={handleCancel}
          >
            Are you sure you want to delete this template?
          </Modal>
          <Section>
            <SmallTitle>Template ID</SmallTitle>
            <Input
              placeholder="Enter the Template ID"
              disabled={!isEdit}
              required
              style={{
                width: "100%",
                height: 32,
                background: "#F9F8FF",
                borderThickness: 1,
                borderColor: "#D9D9D9",
                borderRadius: 2,
                color: "black",
              }}
              value={template}
              onChange={(e) => {
                setTemplate(e.target.value)
                handleAddTemplate(name, e.target.value)
              }}
            />
            {isInvalidMessage === true ? (
              <InvalidText>* The Template ID is duplicate, please enter a different Template ID</InvalidText>
            ) : null}
          </Section>
          <Section team>
            <SmallTitle>Team</SmallTitle>
            {isEdit ? (
              <Select
                placeholder="Select team"
                allowClear
                style={{ width: "100%", height: 32 }}
                value={selectedTeamId}
                onChange={val => handleTeamChange(val)}
                options={(teamsList || []).map(t => ({ label: t.team_name, value: t.team_id }))}
              />
            ) : (
              <TeamText>{getTeamNameById(selectedTeamId)}</TeamText>
            )}
          </Section>
          {isEdit ? (
            <Section action>
              {checkIsDeleted === true ? (
                <Button
                  type="primary"
                  style={{
                    alignSelf: "center",
                  }}
                  disabled
                >
                  Deleted
                </Button>
              ) : (
                <Button
                  style={{
                    alignSelf: "center",
                  }}
                  onClick={() => setDeleteModal(true)}
                >
                  Delete
                </Button>
              )}
            </Section>
          ) : null}
        </InfoDiv>

      )}
    </>
  )
}

const ViewPage = ({
  getListingTotalCommonTemplate,
  getListingTotalCountTemplateResponse,
  getDocusignTemplate,
  getDocusignTemplateResponse,
  templateList,
  setTemplateInvalid,
  templateInvalid,
  setTemplateList,
  createDocusignTemplate,
  deleteTemplates,
  setDeleteTemplates,
  deleteDocusignTemplate,
  fetchStatesMetadata,
  fetchStatesMetadataResponse,
  fetchListingMappingsAll,
  fetchListingMappingsAllResponse,
}) => {
  const [isEdit, setIsEdit] = useState(false)

  const [addNewOG, setAddNewOG] = useState(false)
  const [addNewMLS, setAddNewMLS] = useState(false)
  const [addNewCoList, setAddNewColist] = useState(false)
  const [addNewOwner, setAddNewOwner] = useState(false)
  const [addNewKey, setAddNewKey] = useState(false)
  const [addNewOther, setAddNewOther] = useState(false)

  const [addOGDoc, setAddOGDoc] = useState([1])
  const [addMLSDoc, setAddMLSDoc] = useState([1])
  const [addCoListDoc, setAddCoListDoc] = useState([1])
  const [addOwnerDoc, setAddOwnerDoc] = useState([1])
  const [addKeyDoc, setAddKeyDoc] = useState([1])
  const [addOtherDoc, setAddOtherDoc] = useState([1])
  const [state, setState] = useState("california")
  const [newYorkSubType, setNewYorkSubType] = useState()

  const [valueListingType, setValueListingType] = useState("residential_1_4")
  const [valueCoList, setValueCoList] = useState("radius")
  const [valueOwner, setValueOwner] = useState("trust")

  const [localTemplateData, setLocalTemplateData] = useState([])
  const [localList, setLocalList] = useState([])

  const [saveModal, setSaveModal] = useState(false)
  const [showSpin, setShowSpin] = useState(false)
  const [teamsList, setTeamsList] = useState([])

  const {
    data: templateData,
    isFetching,
  } = getDocusignTemplateResponse || {}

  const {
    data: result,
  } = getListingTotalCountTemplateResponse || {}

  // Helper to get original state name from normalized value for API calls
  const getOriginalStateName = (normalizedState) => {
    if (!fetchListingMappingsAllResponse?.data || !Array.isArray(fetchListingMappingsAllResponse.data)) {
      // Fallback: capitalize first letter of each word
      return normalizedState.replace(/([a-z])([A-Z])/g, '$1 $2')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    }
    const stateData = fetchListingMappingsAllResponse.data.find((s) => 
      s.state.toLowerCase().replace(/\s+/g, '') === normalizedState
    )
    return stateData?.state || normalizedState
  }

  useEffect(() => {
    fetchListingMappingsAll()
    getListingTotalCommonTemplate()
  }, [])

  useEffect(() => {
    fetchComplianceTeamsAPI()
      .then(res => {
        const data = res.data?.response?.data || res.data?.response || []
        setTeamsList(Array.isArray(data) ? data : [])
      })
      .catch(() => setTeamsList([]))
  }, [])

  // Fetch templates when state or subtype changes
  useEffect(() => {
    const originalState = getOriginalStateName(state)
    getDocusignTemplate({ state: originalState, nySubType: newYorkSubType })
  }, [state, newYorkSubType, fetchListingMappingsAllResponse])

  // Get states options from listing mappings API response
  const getStatesOptions = () => {
    if (!fetchListingMappingsAllResponse?.data || !Array.isArray(fetchListingMappingsAllResponse.data)) {
      return []
    }
    return fetchListingMappingsAllResponse.data.map((stateItem) => ({
      label: stateItem.state,
      value: stateItem.state.toLowerCase().replace(/\s+/g, ''),
    }))
  }

  // Get subtypes for a selected state from listing mappings API
  const getSubTypesForState = (stateValue) => {
    if (!fetchListingMappingsAllResponse?.data || !Array.isArray(fetchListingMappingsAllResponse.data)) {
      return []
    }
    // Map the dropdown value back to state name
    const stateData = fetchListingMappingsAllResponse.data.find((s) => 
      s.state.toLowerCase().replace(/\s+/g, '') === stateValue
    )
    if (stateData && stateData.hasSubType && stateData.subtypes) {
      return stateData.subtypes.map((subtype) => ({
        label: subtype.key,
        value: subtype.value,
      }))
    }
    return []
  }

  // Check if state has subtypes
  const stateHasSubTypes = (stateValue) => {
    if (!fetchListingMappingsAllResponse?.data || !Array.isArray(fetchListingMappingsAllResponse.data)) {
      return false
    }
    const stateData = fetchListingMappingsAllResponse.data.find((s) => 
      s.state.toLowerCase().replace(/\s+/g, '') === stateValue
    )
    return stateData?.hasSubType || false
  }

  // Get transaction types for a selected state from listing mappings API
  const getTransactionTypesForState = (stateValue) => {
    if (!fetchListingMappingsAllResponse?.data || !Array.isArray(fetchListingMappingsAllResponse.data)) {
      return [{ value: "residential_1_4", label: "Standard Residential" }]
    }
    const stateData = fetchListingMappingsAllResponse.data.find((s) => 
      s.state.toLowerCase().replace(/\s+/g, '') === stateValue
    )
    if (stateData && stateData.labels && stateData.labels.length > 0) {
      return stateData.labels
    }
    return [{ value: "residential_1_4", label: "Standard Residential" }]
  }

  useEffect(() => {
    if (templateData) {
      templateData.map((x) => {
        templateList.push({
          id: x.id,
          idToAdd: `old-${x.id}`,
          name: x.name,
          templateId: x.template_id,
          entityName: x.entity_name,
          entityType: x.entity_type,
          state: x.state,
          team_id: x.team_id,
          isEdited: false,
        })
      })
      setLocalTemplateData(templateData)
    }
  }, [templateData])

  useEffect(() => {
    if (stateHasSubTypes(state)) {
      // Set default subtype when a state with subtypes is selected
      const subtypes = getSubTypesForState(state)
      if (subtypes.length > 0) {
        setNewYorkSubType(subtypes[0].value)
      }
    } else {
      setNewYorkSubType(undefined)
    }
    // Set default transaction type based on API data
    const transTypes = getTransactionTypesForState(state)
    if (transTypes.length > 0) {
      setValueListingType(transTypes[0].value)
    } else {
      setValueListingType("residential_1_4")
    }
  }, [state, fetchListingMappingsAllResponse])

  const getTotalCountByState = (givenState) => {
    const res = _.find(result, { state: givenState })
    return res ? res.total : 0
  }

  const shouldShowTemplate = (template) => {
    // Normalize state values for comparison (lowercase, no spaces)
    const normalizeState = (s) => s ? s.toLowerCase().replace(/\s+/g, '') : ''
    const normalizedTemplateState = normalizeState(template.state)
    const normalizedSelectedState = normalizeState(state)
    
    // Check if state matches using normalized comparison
    const stateMatches = normalizedTemplateState === normalizedSelectedState
    
    // For states without subtypes, just check state match
    if (!stateHasSubTypes(state)) {
      return stateMatches
    }
    
    // For states with subtypes: if no subtype selected, show all; if selected, filter by subtype
    if (!newYorkSubType) {
      return stateMatches
    }
    
    // Subtype is selected, check if template matches
    const subtypeMatches = template.ny_sub_type === newYorkSubType || template.sub_type === newYorkSubType
    return stateMatches && subtypeMatches
  }

  const addOGDocFunc = () => {
    setAddOGDoc([...addOGDoc, addOGDoc.length])
  }

  const addMLSDocFunc = () => {
    setAddMLSDoc([...addMLSDoc, addMLSDoc.length])
  }

  const addCoListDocFunc = () => {
    setAddCoListDoc([...addCoListDoc, addCoListDoc.length])
  }

  const addOwnerDocFunc = () => {
    setAddOwnerDoc([...addOwnerDoc, addOwnerDoc.length])
  }

  const addKeyDocFunc = () => {
    setAddKeyDoc([...addKeyDoc, addKeyDoc.length])
  }

  const addOtherDocFunc = () => {
    setAddOtherDoc([...addOtherDoc, addOtherDoc.length])
  }

  const saveCancel = () => {
    setSaveModal(false)
  }

  const transactionType = () => {
    let types = [
      {
        value: "residential_1_4",
        label: "Standard Residential",
      },
      {
        value: "vacant_land",
        label: "Vacant Land",
      },
      {
        value: "residential_inc",
        label: "Residential Income Property",
      },
      {
        value: "lease",
        label: "Lease",
      },
    ]
    if (state === "california") {
      types = [...types, 
        {
          value: "manufactured_mo",
          label: "Manufactured / Mobile Home",
        },
      ]
    }
    if (state === "colorado") {
      types = [...types, 
        {
          value: "manufactured_mo",
          label: "Manufactured / Mobile Home",
        },
      ]
    }
     if (state === "florida") {
      types = [...types, 
        {
          value: "nefar",
          label: "NEFAR",
        },
      ]
    }
    if (state === "texas") {
      types = [...types, {
        value: "condominium",
        label: "Condominium",
      },
      {
        value: "new_construction",
        label: "New Construction",
      },
      {
        value: "farm_and_ranch",
        label: "Farm and Ranch",
      },
      {
        value: "commercial",
        label: "Commercial",
      },
      ]
    }
    if (state === "washington") {
      types = [...types, {
        value: "condominium",
        label: "Condominium",
      },
      {
        value: "new_construction",
        label: "New Construction",
      },
      {
        value: "manufactured_mo",
        label: "Manufactured / Mobile Home",
      },
      ]
    }
    if (state === "georgia") {
      types = [...types, {
        value: "commercial",
        label: "Commercial",
      },
      {
        value: "manufactured_mo",
        label: "Manufactured / Mobile Home",
      },
      ]
    }
    if (state === "oregon") {
      types = [...types, {
        value: "new_construction",
        label: "New Construction",
      },
      {
        value: "manufactured_mo",
        label: "Manufactured / Mobile Home",
      },
      ]
    }

    if (state === "arizona") {
      types = [
        {
          value: "residential_listing",
          label: "Residential Listing",
        },
        {
          value: "short_sale_listing",
          label: "Short Sale Listing",
        },
        {
          value: "land_lot_listing",
          label: "Lot/Land Listing",
        },
        {
          value: "residential_lease_listing",
          label: "Residential Lease Listing",
        },
        {
          value: "manufactured_mo",
          label: "Manufactured / Mobile Home",
        },
      ]
    }
    if (state === "newyork") {
      types = [
        {
          value: "commercial_lease_landlord",
          label: "Commercial Lease/Landlord",
        },
        {
          value: "commercial_listing",
          label: "Commercial Listing",
        },
        {
          value: "residential_lease_landlord",
          label: "Residential Lease/Landlord",
        },
        {
          value: "standard_residential_listing",
          label: "Standard Residential Listing",
        },
      ]
    }
    return types
  }

  const checkIfEmpty = () => {
    let isInvalid = null
    if (!isEmpty(templateList)) {
      templateList.find((x) => {
        if ((x.name === "") || (x.templateId === "")) {
          let keyword = null
          if (x.entityType === "transaction_type") keyword = "Type of Listing"
          if (x.entityType === "mls_setup") keyword = "MLS on Market"
          if (x.entityType === "co_listing_agent") keyword = "Co-Listing Agent"
          if (x.entityType === "ownership") keyword = "Ownership"
          if (x.entityType === "other" && x.entityName === "keybox_placement") keyword = "Keysafe / Lockbox"
          if (x.entityType === "other" && x.entityName === "replacement_property_purchase") keyword = "Replacement Property Purchase"
          isInvalid = window.confirm(`Some values for ${keyword} are empty, please fill appropriate details in the empty fields`)
          if (isInvalid) {
            setSaveModal(false)
          }
        }
      })
    }
    return isInvalid
  }

  const saveList = () => {
    console.log("newYorkSubType", newYorkSubType)
    const checking = checkIfEmpty() === true || false
    if (checking === true) {
      setIsEdit(true)
      return
    }
    if (checking === false) {
      if (!isEmpty(templateList)) {
        templateList.forEach((x) => {
          if (x.name !== "" && x.templateId !== "") {
            if (x.isEdited && x.isEdited === true) {
              const templateToAdd = { ...x }
              if (state === "newyork") {
                templateToAdd.state = "New York"
                templateToAdd.nySubType = newYorkSubType
              }
              localList.push(templateToAdd)
            } else if (!("isEdited" in x)) {
              const templateToAdd = { ...x }
              if (state === "newyork") {
                templateToAdd.state = "New York"
                templateToAdd.nySubType = newYorkSubType
              }
              localList.push(templateToAdd)
            }
          }
        })
        if (!isEmpty(localList)) {
          createDocusignTemplate({
            payload: localList,
            callback: () => {
              setShowSpin(false)
              root.location.reload()
            },
          })
          setShowSpin(true)
        }
      }
      if (!isEmpty(deleteTemplates)) {
        deleteTemplates.map((id) => {
          deleteDocusignTemplate({
            id,
            callback: () => {
              setShowSpin(false)
              root.location.reload()
            },
          })
        })
        setShowSpin(true)
      }
      if (isEmpty(deleteTemplates) && isEmpty(localList)) {
        root.location.reload()
      }
      setTemplateList([])
      setLocalList([])
      setIsEdit(false)
      setSaveModal(false)
    }
  }

  return (
    <Wrap>
      <TitleWrap>
        <Title body style={{ margin: 0, marginRight: "510px" }}>Listing Document Packet</Title>
        <Button
          style={{
            width: 170,
            background: "#100063",
            color: "white",
          }}

          onClick={() => {
            root.open("/broker/upload-templates-listing")
          }}
        >
          Document Library [
          <span style={{ color: "white" }}>{getTotalCountByState(state)}</span>
]
        </Button>
      </TitleWrap>
      {showSpin === true ? (
        <Spin
          size="large"
          style={{
            alignSelf: "center",
            marginLeft: "25%",
            marginTop: "25%",
          }}
        />
      ) : (
        <Content>
          <Modal
            title="Save Changes"
            visible={saveModal}
            onOk={saveList}
            onCancel={saveCancel}
          >
            Are you sure you want to save these changes?
          </Modal>
          <HeaderWrap>
            <DropdownDiv>
              <Subtitle>State</Subtitle>
              <Select
                defaultValue="california"
                style={{
                  width: 367,
                  marginLeft: 20,
                  marginTop: 0,
                }}
                disabled={isEdit}
                loading={fetchListingMappingsAllResponse?.isFetching}
                onChange={(value) => {
                  setState(value)
                }}
                options={getStatesOptions()}
              />
            </DropdownDiv>
            {stateHasSubTypes(state) && (
              <DropdownDiv>
                <Subtitle>Sub Type</Subtitle>
                <Select
                  value={newYorkSubType}
                  style={{
                    width: 367,
                    marginLeft: 20,
                    marginTop: 0,
                  }}
                  disabled={isEdit}
                  onChange={(value) => {
                    setNewYorkSubType(value)
                  }}
                  options={getSubTypesForState(state)}
                />
              </DropdownDiv>
            )}
            {isEdit === false ? (
              <Button
                style={{
                  width: 170,
                  background: "#100063",
                  color: "white",
                }}
                onClick={() => {
                  setIsEdit(true)
                }}
              >
                Edit
              </Button>

            ) : (
              <Button
                style={{
                  width: 170,
                  background: "#24AE60",
                  color: "white",
                }}
                disabled={templateInvalid}
                onClick={() => {
                  setSaveModal(true)
                }}
              >
                Save
              </Button>
            )}
          </HeaderWrap>
          <HR />
          <Body>
            <TitleDiv>
              <Title body>Type of listing</Title>
              <Select
                value={valueListingType}
                style={{
                  width: 367,
                  marginLeft: 20,
                  marginTop: 0,
                }}
                onChange={(value) => {
                  setValueListingType(value)
                }}
                options={getTransactionTypesForState(state)}
              />
            </TitleDiv>
            {isFetching === true ? (
              <Loader />
            ) : (
              <>
                {localTemplateData && !isEmpty(localTemplateData) ? localTemplateData.map(x => (
                  <>
                    {x.entity_type.includes("transaction_type") && x.entity_name === valueListingType ? (
                      <>
                        {shouldShowTemplate(x) ? (
                          <TitleAndTemplate
                            index={`old-${x.id}`}
                            deleteTemplates={deleteTemplates}
                            setDeleteTemplates={setDeleteTemplates}
                            templateData={templateData}
                            localTemplateData={localTemplateData}
                            setLocalTemplateData={setLocalTemplateData}
                            isShifted={false}
                            state={state}
                            templateList={templateList}
                            setTemplateList={setTemplateList}
                            entityName={valueListingType}
                            entityType="transaction_type"
                            isEdit={isEdit}
                            addArray={addOGDoc}
                            setAddArray={setAddOGDoc}
                            valueName={x.name}
                            setTemplateInvalid={setTemplateInvalid}
                            valueTemplate={x.template_id}
                          teamsList={teamsList}
                          />
                        ) : null}
                      </>
                    ) : null}
                  </>
                )) : (
                  <Text>No documents added for this category yet.</Text>
                )}
              </>
            )}
            {addNewOG === true ? (
              <>
                {addOGDoc.length && addOGDoc.map((x, i) => (
                  <>
                    {i > 0 && (
                      <TitleAndTemplate
                        addArray={addOGDoc}
                        setAddArray={setAddOGDoc}
                        index={`new-og-${i}`}
                        templateData={templateData}
                        isShifted={false}
                        state={state}
                        templateList={templateList}
                        setTemplateList={setTemplateList}
                        setTemplateInvalid={setTemplateInvalid}
                        entityName={valueListingType}
                        entityType="transaction_type"
                        isEdit={isEdit}
                      teamsList={teamsList}
                      />
                    )}
                  </>
                ))}
              </>
            ) : null}
            {isEdit === true ? (
              <AddNewDoc
                onClick={() => {
                  setAddNewOG(true)
                  addOGDocFunc()
                  templateList.push({
                    idToAdd: `new-og-${addOGDoc.length}`,
                    name: "",
                    templateId: "",
                    entityName: valueListingType,
                    entityType: "transaction_type",
                    state,
                  })
                }}
              >
                <Image src={PlusSign} />
                <AddNew>Add New Document </AddNew>
              </AddNewDoc>
            ) : null}
            {
              state !== "arizona" && (
                <>
                  <AdditionDocuments>
                    {isEdit === false ? (
                      <Title body>Additional Documents</Title>
                    ) : (
                      <Divider>
                        <SmallHR />
                        <SmallText>Additional Documents</SmallText>
                        <SmallHR />
                      </Divider>
                    )
                    }
                    <MLSDiv>
                      <Subtitle body>MLS on Market</Subtitle>
                      <Switch
                        checkedChildren="Yes"
                        unCheckedChildren="No"
                        defaultChecked={false}
                        disabled
                      />
                      {/* <Text>(Yes)</Text> */}
                    </MLSDiv>
                    <Text>
                      If there is more than a three days difference between the Listing Date and MLS
                      Date OR Seller elects for property to not be marked to the public at all:
                    </Text>
                    <Text>
                      If Yes: (SELM)
                      Seller Instruction to Exclude Listing From MLS
                    </Text>
                    {isFetching === true ? (
                      <Loader />
                    ) : (
                <>
                  {!isEmpty(localTemplateData) && localTemplateData ? localTemplateData.map(x => (
                    <>
                      {x.entity_type.includes("mls_setup") ? (
                        <>
                          {shouldShowTemplate(x) ? (
                            <TitleAndTemplate
                              index={`old-${x.id}`}
                              deleteTemplates={deleteTemplates}
                              setDeleteTemplates={setDeleteTemplates}
                              templateData={templateData}
                              localTemplateData={localTemplateData}
                              setLocalTemplateData={setLocalTemplateData}
                              addArray={addMLSDoc}
                              setAddArray={setAddMLSDoc}
                              isShifted={false}
                              state={state}
                              templateList={templateList}
                              setTemplateList={setTemplateList}
                              setTemplateInvalid={setTemplateInvalid}
                              entityName={["mls_date_listing_date_diff"]}
                              entityType="mls_setup"
                              isEdit={isEdit}
                              valueName={x.name}
                              valueTemplate={x.template_id}
                            teamsList={teamsList}
                            />
                          ) : null}
                        </>
                      ) : null}
                    </>
                  )) : (
                    <Text>No documents added for this category yet.</Text>
                  )}
                </>
                    )}
                    {addNewMLS === true ? (
                <>
                  {addMLSDoc.length && addMLSDoc.map((x, i) => (
                    <>
                      {i > 0 && (
                        <TitleAndTemplate
                          addArray={addMLSDoc}
                          setAddArray={setAddMLSDoc}
                          index={`new-mls-${i}`}
                          templateData={templateData}
                          isShifted={false}
                          state={state}
                          templateList={templateList}
                          setTemplateList={setTemplateList}
                          setTemplateInvalid={setTemplateInvalid}
                          entityName={["mls_date_listing_date_diff"]}
                          entityType="mls_setup"
                          isEdit={isEdit}
                        teamsList={teamsList}
                        />
                      )}
                    </>
                  ))}
                </>
                    ) : null}
                    {isEdit === true ? (
                      <AddNewDoc
                        onClick={() => {
                          setAddNewMLS(true)
                          addMLSDocFunc()
                          templateList.push({
                            idToAdd: `new-mls-${addMLSDoc.length}`,
                            name: "",
                            templateId: "",
                            entityName: "mls_date_listing_date_diff",
                            entityType: "mls_setup",
                            state,
                          })
                        }}
                      >
                        <Image src={PlusSign} />
                        <AddNew>Add New Document </AddNew>
                      </AddNewDoc>
                    ) : null}
                    <HR />
                  </AdditionDocuments>
                </>
              )
            }
            {
              state !== "arizona" && (
                <>
                  <CoListingDiv>
                    <DropdownDiv>
                      <Subtitle>Co listing Agent</Subtitle>
                      <Select
                        defaultValue="From Radius"
                        style={{
                          width: 367,
                          marginLeft: 20,
                          marginTop: 0,
                        }}
                        onChange={(value) => {
                          setValueCoList(value)
                        }}
                        options={[
                          {
                            value: "radius",
                            label: "From Radius",
                          },
                          {
                            value: "non_radius",
                            label: "Not From Radius",
                          },
                        ]}
                      />
                    </DropdownDiv>
                    {isFetching === true ? (
                      <Loader />
                    ) : (
                <>
                  {localTemplateData && !isEmpty(localTemplateData) ? localTemplateData.map(x => (
                    <>
                      {x.entity_type.includes("co_listing_agent") && x.entity_name === valueCoList ? (
                        <>
                          {shouldShowTemplate(x) ? (
                            <TitleAndTemplate
                              index={`old-${x.id}`}
                              deleteTemplates={deleteTemplates}
                              setDeleteTemplates={setDeleteTemplates}
                              templateData={templateData}
                              localTemplateData={localTemplateData}
                              setLocalTemplateData={setLocalTemplateData}
                              addArray={addCoListDoc}
                              setAddArray={setAddCoListDoc}
                              isShifted
                              state={state}
                              templateList={templateList}
                              setTemplateInvalid={setTemplateInvalid}
                              setTemplateList={setTemplateList}
                              entityName={valueCoList}
                              entityType="co_listing_agent"
                              toAdd={addNewCoList}
                              isEdit={isEdit}
                              valueName={x.name}
                              valueTemplate={x.template_id}
                            teamsList={teamsList}
                            />
                          ) : null}
                        </>
                      ) : null}
                    </>
                  )) : (
                    <Text>No documents added for this category yet.</Text>
                  )}
                </>
                    )}
                    {addNewCoList === true ? (
                <>
                  {addCoListDoc.length && addCoListDoc.map((x, i) => (
                    <>
                      {i > 0 && (
                        <TitleAndTemplate
                          addArray={addCoListDoc}
                          setAddArray={setAddCoListDoc}
                          index={`new-colist-${i}`}
                          templateData={templateData}
                          isShifted
                          state={state}
                          templateList={templateList}
                          setTemplateInvalid={setTemplateInvalid}
                          setTemplateList={setTemplateList}
                          entityName={valueCoList}
                          entityType="co_listing_agent"
                          isEdit={isEdit}
                        teamsList={teamsList}
                        />
                      )}
                    </>
                  ))}
                </>
                    ) : null}
                    {isEdit === true ? (
                      <AddNewDoc
                        onClick={() => {
                          setAddNewColist(true)
                          addCoListDocFunc()
                          templateList.push({
                            idToAdd: `new-colist-${addCoListDoc.length}`,
                            name: "",
                            templateId: "",
                            entityName: valueCoList,
                            entityType: "co_listing_agent",
                            state,
                          })
                        }}
                      >
                        <Image src={PlusSign} />
                        <AddNew>Add New Document </AddNew>
                      </AddNewDoc>
                    ) : null}
                    <HR colist />
                  </CoListingDiv>
                </>
              )
            }
            {
              state !== "arizona" && (
                <>
                  <OwnershipDiv>
                    <DropdownDiv>
                      <Subtitle>Ownership</Subtitle>
                      <Select
                        defaultValue="Trust"
                        style={{
                          width: 367,
                          marginLeft: 20,
                          marginTop: 0,
                        }}
                        onChange={(value) => {
                          setValueOwner(value)
                        }}
                        options={[
                          {
                            value: "trust",
                            label: "Trust",
                          },
                          {
                            value: "successor_trust",
                            label: "Successor Trust",
                          },
                          {
                            value: "entity",
                            label: "Entity",
                          },
                          {
                            value: "probate",
                            label: "Probate",
                          },
                          {
                            value: "power_of_attorney",
                            label: "Power Of Attorney",
                          },
                          {
                            value: "estate",
                            label: "Estate",
                          },
                        ]}
                      />
                    </DropdownDiv>
                    {isFetching === true ? (
                      <Loader />
                    ) : (
                <>
                  {localTemplateData && !isEmpty(localTemplateData) ? localTemplateData.map(x => (
                    <>
                      {x.entity_type.includes("ownership") && x.entity_name === valueOwner ? (
                        <>
                          {shouldShowTemplate(x) ? (
                            <TitleAndTemplate
                              index={`old-${x.id}`}
                              deleteTemplates={deleteTemplates}
                              setDeleteTemplates={setDeleteTemplates}
                              templateData={templateData}
                              localTemplateData={localTemplateData}
                              setLocalTemplateData={setLocalTemplateData}
                              addArray={addOwnerDoc}
                              setAddArray={setAddOwnerDoc}
                              isShifted
                              state={state}
                              templateList={templateList}
                              setTemplateInvalid={setTemplateInvalid}
                              setTemplateList={setTemplateList}
                              entityName={valueOwner}
                              entityType="ownership"
                              isEdit={isEdit}
                              valueName={x.name}
                              valueTemplate={x.template_id}
                            teamsList={teamsList}
                            />
                          ) : null}
                        </>
                      ) : null}
                    </>
                  )) : (
                    <Text>No documents added for this category yet.</Text>
                  )}
                </>
                    )}
                    {addNewOwner === true ? (
                <>
                  {addOwnerDoc.length && addOwnerDoc.map((x, i) => (
                    <>
                      {i > 0 && (
                        <TitleAndTemplate
                          addArray={addOwnerDoc}
                          setAddArray={setAddOwnerDoc}
                          index={`new-owner-${i}`}
                          templateData={templateData}
                          isShifted
                          state={state}
                          templateList={templateList}
                          setTemplateInvalid={setTemplateInvalid}
                          setTemplateList={setTemplateList}
                          entityName={valueOwner}
                          entityType="ownership"
                          isEdit={isEdit}
                        teamsList={teamsList}
                        />
                      )}
                    </>
                  ))}
                </>
                    ) : null}
                    {isEdit === true ? (
                      <AddNewDoc
                        onClick={() => {
                          setAddNewOwner(true)
                          addOwnerDocFunc()
                          templateList.push({
                            idToAdd: `new-owner-${addOwnerDoc.length}`,
                            name: "",
                            templateId: "",
                            entityName: valueOwner,
                            entityType: "ownership",
                            state,
                          })
                        }}
                      >
                        <Image src={PlusSign} />
                        <AddNew>Add New Document </AddNew>
                      </AddNewDoc>
                    ) : null}
                    <HR colist />
                  </OwnershipDiv>
                </>
              )
            }
            {
              state !== "arizona" && (
                <>
                  <KeysafeDiv>
                    <MLSDiv>
                      <Subtitle>Keysafe / Lockbox</Subtitle>
                      <Switch
                        checkedChildren="Yes"
                        unCheckedChildren="No"
                        defaultChecked
                        disabled
                        style={{
                          marginTop: 7,
                        }}
                      />
                    </MLSDiv>
                    <Text colist>
                Keysafe/Lockbox to be placed on the property.
                    </Text>
                    {isFetching === true ? (
                      <Loader />
                    ) : (
                <>
                  {localTemplateData && !isEmpty(localTemplateData) ? localTemplateData.map(x => (
                    <>
                      {x.entity_type.includes("other") && x.entity_name === "keybox_placement" ? (
                        <>
                          {shouldShowTemplate(x) ? (
                            <TitleAndTemplate
                              index={`old-${x.id}`}
                              deleteTemplates={deleteTemplates}
                              setDeleteTemplates={setDeleteTemplates}
                              templateData={templateData}
                              localTemplateData={localTemplateData}
                              setLocalTemplateData={setLocalTemplateData}
                              addArray={addKeyDoc}
                              setAddArray={setAddKeyDoc}
                              isShifted
                              state={state}
                              templateList={templateList}
                              setTemplateInvalid={setTemplateInvalid}
                              setTemplateList={setTemplateList}
                              entityName="keybox_placement"
                              entityType="other"
                              isEdit={isEdit}
                              valueName={x.name}
                              valueTemplate={x.template_id}
                            teamsList={teamsList}
                            />
                          ) : null}
                        </>
                      ) : null}
                    </>
                  )) : (
                    <Text>No documents added for this category yet.</Text>
                  )}
                </>
                    )}
                    {addNewKey === true ? (
                <>
                  {addKeyDoc.length && addKeyDoc.map((x, i) => (
                    <>
                      {i > 0 && (
                        <TitleAndTemplate
                          addArray={addKeyDoc}
                          setAddArray={setAddKeyDoc}
                          index={`new-key-${i}`}
                          templateData={templateData}
                          isShifted
                          state={state}
                          templateList={templateList}
                          setTemplateInvalid={setTemplateInvalid}
                          setTemplateList={setTemplateList}
                          entityName="keybox_placement"
                          entityType="other"
                          toAdd={addNewKey}
                          isEdit={isEdit}
                        teamsList={teamsList}
                        />
                      )}
                    </>
                  ))}
                </>
                    ) : null}
                    {isEdit === true ? (
                      <AddNewDoc
                        onClick={() => {
                          setAddNewKey(true)
                          addKeyDocFunc()
                          templateList.push({
                            idToAdd: `new-key-${addKeyDoc.length}`,
                            name: "",
                            templateId: "",
                            entityName: "keybox_placement",
                            entityType: "other",
                            state,
                          })
                        }}
                      >
                        <Image src={PlusSign} />
                        <AddNew>Add New Document </AddNew>
                      </AddNewDoc>
                    ) : null}
                    <HR colist />
                  </KeysafeDiv>
                </>
              )
            }
            {
              state !== "arizona" && (
                <>
                  <KeysafeDiv>
                    <MLSDiv contingency>
                      <Subtitle>Does Seller Intend to include a contingency to purchase a replacement property?</Subtitle>
                      <Switch
                        checkedChildren="Yes"
                        unCheckedChildren="No"
                        defaultChecked
                        disabled
                        style={{
                          marginTop: 7,
                        }}
                      />
                    </MLSDiv>
                    {isFetching === true ? (
                      <Loader />
                    ) : (
                <>
                  {localTemplateData && !isEmpty(localTemplateData) ? localTemplateData.map(x => (
                    <>
                      {x.entity_type.includes("other") && x.entity_name === "replacement_property_purchase" ? (
                        <>
                          {shouldShowTemplate(x) ? (
                            <TitleAndTemplate
                              index={`old-${x.id}`}
                              deleteTemplates={deleteTemplates}
                              setDeleteTemplates={setDeleteTemplates}
                              templateData={templateData}
                              localTemplateData={localTemplateData}
                              setLocalTemplateData={setLocalTemplateData}
                              addArray={addOtherDoc}
                              setAddArray={setAddOtherDoc}
                              isShifted
                              state={state}
                              templateList={templateList}
                              setTemplateInvalid={setTemplateInvalid}
                              setTemplateList={setTemplateList}
                              entityName="replacement_property_purchase"
                              entityType="other"
                              isEdit={isEdit}
                              valueName={x.name}
                              valueTemplate={x.template_id}
                            teamsList={teamsList}
                            />
                          ) : null}
                        </>
                      ) : null}
                    </>
                  )) : (
                    <Text>No documents added for this category yet.</Text>
                  )}
                </>
                    )}
                    {addNewOther === true ? (
                <>
                  {addOtherDoc.length && addOtherDoc.map((x, i) => (
                    <>
                      {i > 0 && (
                        <TitleAndTemplate
                          addArray={addOtherDoc}
                          setAddArray={setAddOtherDoc}
                          index={`new-replacement-${i}`}
                          templateData={templateData}
                          isShifted
                          state={state}
                          templateList={templateList}
                          setTemplateInvalid={setTemplateInvalid}
                          setTemplateList={setTemplateList}
                          entityName="replacement_property_purchase"
                          entityType="other"
                          isEdit={isEdit}
                        teamsList={teamsList}
                        />
                      )}
                    </>
                  ))}
                </>
                    ) : null}
                    {isEdit === true ? (
                      <AddNewDoc
                        onClick={() => {
                          setAddNewOther(true)
                          addOtherDocFunc()
                          templateList.push({
                            idToAdd: `new-replacement-${addOtherDoc.length}`,
                            name: "",
                            templateId: "",
                            entityName: "replacement_property_purchase",
                            entityType: "other",
                            state,
                          })
                        }}
                      >
                        <Image src={PlusSign} />
                        <AddNew>Add New Document </AddNew>
                      </AddNewDoc>
                    ) : null}
                    <HR last />
                  </KeysafeDiv>
                </>
              )
            }

          </Body>
        </Content>
      )}
    </Wrap>
  )
}

export default container(ViewPage)
